// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bct_a bic_ke","ListItemIcon--empty":"bct_b bic_fl"};